
import React from 'react';
import { MapPin } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface MapErrorStateProps {
  address: string;
  showCard?: boolean;
  className?: string;
}

export function MapErrorState({ address, showCard = true, className = '' }: MapErrorStateProps) {
  const handleRetry = () => {
    window.location.reload();
  };

  const content = (
    <div className="bg-gray-100 rounded-lg p-4 flex items-center justify-center">
      <div className="text-center">
        <MapPin className="h-10 w-10 text-gray-400 mx-auto mb-2" />
        <p className="text-gray-600 font-medium mb-1">Map temporarily unavailable</p>
        <p className="text-gray-500 text-sm line-clamp-2 mb-3">{address}</p>
        <div className="flex justify-center gap-2">
          <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="inline-flex items-center gap-1 px-3 py-2 bg-grandpal-green text-white rounded hover:bg-grandpal-green-dark transition-colors">
            <MapPin className="h-4 w-4" />
            Get Directions
          </a>
          <Button 
            variant="outline" 
            size="sm"
            onClick={handleRetry}
          >
            Retry
          </Button>
        </div>
      </div>
    </div>
  );

  if (showCard) {
    return (
      <Card className={`overflow-hidden ${className}`}>
        <CardHeader className="pb-2">
          <CardTitle className="text-xl">Location</CardTitle>
        </CardHeader>
        <CardContent>
          {content}
        </CardContent>
      </Card>
    );
  }
  
  return content;
}
